export default "__VITE_ASSET__c769d604__"